import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export const usePostOrderExcelForm = (successCallback?: () => void, errorCallback?: (error: any) => void) => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async () => {
            const response = await axios.post(
                enum_api_uri.post_order_excel_form,
                {},
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                    responseType: "blob",
                },
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute("download", "주문엑셀양식.xlsx");

            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        },
        onSuccess: () => {
            successCallback?.();
        },
    });
};
